import bohoWrap1 from "@/assets/products/boho-wrap-1.jpg";
import minimalistCuff1 from "@/assets/products/minimalist-cuff-1.jpg";
import friendshipOcean1 from "@/assets/products/friendship-ocean-1.jpg";
import charmAnklet1 from "@/assets/products/charm-anklet-1.jpg";
import leatherWrap1 from "@/assets/products/leather-wrap-1.jpg";
import beadedCuff1 from "@/assets/products/beaded-cuff-1.jpg";
import beadedRosequartz1 from "@/assets/products/beaded-rosequartz-1.jpg";
import friendshipDaisy1 from "@/assets/products/friendship-daisy-1.jpg";
import bohoMacrame1 from "@/assets/products/boho-macrame-1.jpg";
import charmSilverLeaf1 from "@/assets/products/charm-silver-leaf-1.jpg";
import bohoStack1 from "@/assets/products/boho-stack-1.jpg";
import minimalistCrystal1 from "@/assets/products/minimalist-crystal-1.jpg";
import bohoLavender1 from "@/assets/products/boho-lavender-1.jpg";
import charmShellAnklet1 from "@/assets/products/charm-shell-anklet-1.jpg";
import beadedEmber1 from "@/assets/products/beaded-ember-1.jpg";
import leatherNordic1 from "@/assets/products/leather-nordic-1.jpg";
import friendshipRainbow1 from "@/assets/products/friendship-rainbow-1.jpg";
import beadedJade1 from "@/assets/products/beaded-jade-1.jpg";
import minimalistCopper1 from "@/assets/products/minimalist-copper-1.jpg";
import charmStarlight1 from "@/assets/products/charm-starlight-1.jpg";
import bohoSahara1 from "@/assets/products/boho-sahara-1.jpg";
import charmPeach1 from "@/assets/products/charm-peach-1.jpg";
import beadedMossagate1 from "@/assets/products/beaded-mossagate-1.jpg";
import friendshipCandy1 from "@/assets/products/friendship-candy-1.jpg";
import bohoVintageLace1 from "@/assets/products/boho-vintage-lace-1.jpg";
import beadedOnyx1 from "@/assets/products/beaded-onyx-1.jpg";
import friendshipTropical1 from "@/assets/products/friendship-tropical-1.jpg";
import minimalistBronze1 from "@/assets/products/minimalist-bronze-1.jpg";
import charmCherryblossom1 from "@/assets/products/charm-cherryblossom-1.jpg";
import leatherInitial1 from "@/assets/products/leather-initial-1.jpg";

export interface Product {
  id: string;
  name: string;
  price: number;
  cogs: number;
  description: string;
  style: string;
  material: string;
  colors: string[];
  rating: number;
  reviewCount: number;
  bestseller: boolean;
  newArrival: boolean;
  sizes: string[];
  careInfo: string;
  gradient: string;
  image: string;
}

const gradients = [
  "linear-gradient(135deg, #e8a87c, #d4a574)",
  "linear-gradient(135deg, #c9ada7, #9a8c98)",
  "linear-gradient(135deg, #b5c7a3, #8fa67a)",
  "linear-gradient(135deg, #f2cc8f, #e07a5f)",
  "linear-gradient(135deg, #81b29a, #3d405b)",
  "linear-gradient(135deg, #f4a261, #e76f51)",
  "linear-gradient(135deg, #cdb4db, #a2d2ff)",
  "linear-gradient(135deg, #fec89a, #f8ad9d)",
  "linear-gradient(135deg, #d4e09b, #a8dadc)",
  "linear-gradient(135deg, #e5989b, #b5838d)",
  "linear-gradient(135deg, #ffb4a2, #e5989b)",
  "linear-gradient(135deg, #6d6875, #b5838d)",
  "linear-gradient(135deg, #ccd5ae, #e9edc9)",
  "linear-gradient(135deg, #d5c6e0, #aab6d3)",
  "linear-gradient(135deg, #f0efeb, #d4c5a9)",
  "linear-gradient(135deg, #e8d5b7, #b08968)",
  "linear-gradient(135deg, #a8dadc, #457b9d)",
  "linear-gradient(135deg, #ffd6ff, #e7c6ff)",
  "linear-gradient(135deg, #caffbf, #9bf6ff)",
  "linear-gradient(135deg, #ffc6ff, #bdb2ff)",
  "linear-gradient(135deg, #fdffb6, #ffd6a5)",
  "linear-gradient(135deg, #a0c4ff, #bdb2ff)",
  "linear-gradient(135deg, #f9c74f, #f8961e)",
  "linear-gradient(135deg, #90be6d, #43aa8b)",
  "linear-gradient(135deg, #f94144, #f3722c)",
  "linear-gradient(135deg, #577590, #43aa8b)",
  "linear-gradient(135deg, #f8961e, #f9844a)",
  "linear-gradient(135deg, #4d908e, #277da1)",
  "linear-gradient(135deg, #e9c46a, #f4a261)",
  "linear-gradient(135deg, #264653, #2a9d8f)",
];

export const products: Product[] = [
  {
    id: "1", name: "Sunset Boho Wrap", price: 28, cogs: 8,
    description: "A free-spirited wrap bracelet featuring warm sunset tones woven with natural cotton thread. Each one is hand-tied with love, making every piece truly unique.",
    style: "Boho", material: "Thread", colors: ["Orange", "Gold", "Brown"],
    rating: 4.8, reviewCount: 124, bestseller: true, newArrival: false,
    sizes: ["Adjustable"], careInfo: "Avoid water. Store flat.", gradient: gradients[0],
    image: bohoWrap1,
  },
  {
    id: "2", name: "Golden Thread Minimalist Cuff", price: 35, cogs: 12,
    description: "Elegant simplicity at its finest. This delicate gold-thread cuff pairs beautifully with any outfit, from casual to evening wear.",
    style: "Minimalist", material: "Wire", colors: ["Gold"],
    rating: 4.9, reviewCount: 89, bestseller: true, newArrival: false,
    sizes: ["S/M", "M/L"], careInfo: "Wipe gently with soft cloth.", gradient: gradients[1],
    image: minimalistCuff1,
  },
  {
    id: "3", name: "Ocean Bead Friendship Set", price: 22, cogs: 6,
    description: "Share the love with this matching friendship bracelet set. Inspired by ocean blues with hand-threaded glass beads.",
    style: "Friendship", material: "Beads", colors: ["Blue", "Teal", "White"],
    rating: 4.7, reviewCount: 203, bestseller: true, newArrival: false,
    sizes: ["Adjustable"], careInfo: "Remove before swimming.", gradient: gradients[2],
    image: friendshipOcean1,
  },
  {
    id: "4", name: "Terracotta Charm Anklet", price: 19, cogs: 5,
    description: "A dainty anklet with hand-pressed terracotta charms on a natural hemp cord. Perfect for summer days.",
    style: "Charm", material: "Thread", colors: ["Terracotta", "Natural"],
    rating: 4.6, reviewCount: 67, bestseller: false, newArrival: true,
    sizes: ["Adjustable"], careInfo: "Avoid prolonged water exposure.", gradient: gradients[3],
    image: charmAnklet1,
  },
  {
    id: "5", name: "Midnight Leather Wrap", price: 42, cogs: 16,
    description: "A sophisticated leather wrap bracelet with a magnetic clasp. Hand-stitched from genuine leather with antique brass details.",
    style: "Minimalist", material: "Leather", colors: ["Black", "Brown"],
    rating: 4.8, reviewCount: 156, bestseller: true, newArrival: false,
    sizes: ["S/M", "M/L"], careInfo: "Condition leather monthly.", gradient: gradients[4],
    image: leatherWrap1,
  },
  {
    id: "6", name: "Wildflower Beaded Cuff", price: 32, cogs: 11,
    description: "A vibrant beaded cuff featuring a hand-woven wildflower pattern. Each bead is individually placed for a stunning mosaic effect.",
    style: "Beaded", material: "Beads", colors: ["Multi", "Pink", "Green"],
    rating: 4.5, reviewCount: 91, bestseller: false, newArrival: false,
    sizes: ["S/M", "M/L"], careInfo: "Handle with care. Store in pouch.", gradient: gradients[5],
    image: beadedCuff1,
  },
  {
    id: "7", name: "Rose Quartz Healing Band", price: 38, cogs: 10,
    description: "Genuine rose quartz stones strung on elastic cord. Known for promoting love and emotional healing.",
    style: "Beaded", material: "Beads", colors: ["Pink", "Rose"],
    rating: 4.9, reviewCount: 178, bestseller: true, newArrival: false,
    sizes: ["Adjustable"], careInfo: "Cleanse under moonlight.", gradient: gradients[6],
    image: beadedRosequartz1,
  },
  {
    id: "8", name: "Daisy Chain Friendship Band", price: 15, cogs: 3,
    description: "A sweet daisy chain bracelet made with seed beads. Perfect for gifting to your best friend.",
    style: "Friendship", material: "Beads", colors: ["White", "Yellow", "Green"],
    rating: 4.4, reviewCount: 312, bestseller: false, newArrival: false,
    sizes: ["Adjustable"], careInfo: "Avoid snagging on fabrics.", gradient: gradients[7],
    image: friendshipDaisy1,
  },
  {
    id: "9", name: "Boho Macramé Festival Cuff", price: 26, cogs: 7,
    description: "Hand-knotted macramé bracelet with wooden beads. Festival-ready and full of character.",
    style: "Boho", material: "Thread", colors: ["Natural", "Brown"],
    rating: 4.6, reviewCount: 145, bestseller: false, newArrival: false,
    sizes: ["Adjustable"], careInfo: "Spot clean only.", gradient: gradients[8],
    image: bohoMacrame1,
  },
  {
    id: "10", name: "Silver Leaf Charm Bracelet", price: 45, cogs: 15,
    description: "Delicate silver-plated leaf charms on a fine chain. Nature-inspired elegance for everyday wear.",
    style: "Charm", material: "Wire", colors: ["Silver"],
    rating: 4.7, reviewCount: 98, bestseller: false, newArrival: true,
    sizes: ["S/M", "M/L"], careInfo: "Polish with silver cloth.", gradient: gradients[9],
    image: charmSilverLeaf1,
  },
  {
    id: "11", name: "Woven Earth Tones Stack", price: 48, cogs: 14,
    description: "A set of three stackable woven bracelets in earthy tones. Mix and match for your perfect combo.",
    style: "Boho", material: "Thread", colors: ["Brown", "Olive", "Rust"],
    rating: 4.8, reviewCount: 76, bestseller: false, newArrival: false,
    sizes: ["Adjustable"], careInfo: "Remove before showering.", gradient: gradients[10],
    image: bohoStack1,
  },
  {
    id: "12", name: "Crystal Clear Minimalist Band", price: 29, cogs: 8,
    description: "A single clear crystal bead on a silk cord. Understated luxury that catches the light beautifully.",
    style: "Minimalist", material: "Beads", colors: ["Clear", "White"],
    rating: 4.5, reviewCount: 134, bestseller: false, newArrival: false,
    sizes: ["Adjustable"], careInfo: "Keep away from chemicals.", gradient: gradients[11],
    image: minimalistCrystal1,
  },
  {
    id: "13", name: "Lavender Fields Wrap", price: 34, cogs: 9,
    description: "Inspired by Provence lavender fields. Soft purple threads with tiny silver bead accents.",
    style: "Boho", material: "Thread", colors: ["Purple", "Silver"],
    rating: 4.7, reviewCount: 88, bestseller: false, newArrival: true,
    sizes: ["Adjustable"], careInfo: "Store in dry place.", gradient: gradients[13],
    image: bohoLavender1,
  },
  {
    id: "14", name: "Coastal Shell Anklet", price: 21, cogs: 6,
    description: "Tiny shell fragments and sea glass beads on a waterproof cord. Bring the beach everywhere you go.",
    style: "Charm", material: "Beads", colors: ["White", "Aqua", "Sandy"],
    rating: 4.3, reviewCount: 167, bestseller: false, newArrival: false,
    sizes: ["Adjustable"], careInfo: "Water-resistant. Pat dry after swimming.", gradient: gradients[14],
    image: charmShellAnklet1,
  },
  {
    id: "15", name: "Ember Glow Beaded Set", price: 52, cogs: 18,
    description: "A luxurious set of two beaded bracelets featuring warm amber and garnet-colored glass beads.",
    style: "Beaded", material: "Beads", colors: ["Red", "Amber", "Gold"],
    rating: 4.8, reviewCount: 54, bestseller: false, newArrival: true,
    sizes: ["S/M", "M/L"], careInfo: "Handle gently. Store separately.", gradient: gradients[15],
    image: beadedEmber1,
  },
  {
    id: "16", name: "Nordic Knot Leather Band", price: 39, cogs: 15,
    description: "A braided leather bracelet inspired by Nordic knot patterns. Rugged yet refined.",
    style: "Minimalist", material: "Leather", colors: ["Brown", "Tan"],
    rating: 4.6, reviewCount: 112, bestseller: false, newArrival: false,
    sizes: ["S/M", "M/L"], careInfo: "Condition with leather balm.", gradient: gradients[16],
    image: leatherNordic1,
  },
  {
    id: "17", name: "Rainbow Thread Friendship Set", price: 18, cogs: 4,
    description: "Set of 5 vibrant friendship bracelets. Hand-braided with love in every color of the rainbow.",
    style: "Friendship", material: "Thread", colors: ["Multi"],
    rating: 4.5, reviewCount: 423, bestseller: true, newArrival: false,
    sizes: ["Adjustable"], careInfo: "Tie securely. Remove before bathing.", gradient: gradients[17],
    image: friendshipRainbow1,
  },
  {
    id: "18", name: "Jade Serenity Stretch", price: 44, cogs: 14,
    description: "Natural jade stone beads on a stretch cord. A timeless piece believed to bring harmony and balance.",
    style: "Beaded", material: "Beads", colors: ["Green", "Jade"],
    rating: 4.9, reviewCount: 201, bestseller: true, newArrival: false,
    sizes: ["S/M", "M/L"], careInfo: "Wipe with damp cloth.", gradient: gradients[18],
    image: beadedJade1,
  },
  {
    id: "19", name: "Copper Wire Twist Cuff", price: 36, cogs: 13,
    description: "An artisan copper wire cuff twisted by hand. Develops a beautiful patina over time.",
    style: "Minimalist", material: "Wire", colors: ["Copper"],
    rating: 4.4, reviewCount: 73, bestseller: false, newArrival: false,
    sizes: ["Adjustable"], careInfo: "May patina naturally. Polish if desired.", gradient: gradients[19],
    image: minimalistCopper1,
  },
  {
    id: "20", name: "Starlight Charm Collection", price: 55, cogs: 18,
    description: "A deluxe charm bracelet featuring moon, star, and celestial charms on a sterling-plated chain.",
    style: "Charm", material: "Wire", colors: ["Silver", "Gold"],
    rating: 4.8, reviewCount: 189, bestseller: true, newArrival: false,
    sizes: ["S/M", "M/L"], careInfo: "Avoid moisture. Store in jewelry box.", gradient: gradients[20],
    image: charmStarlight1,
  },
  {
    id: "21", name: "Sahara Sand Wrap", price: 31, cogs: 9,
    description: "Desert-inspired wrap bracelet with natural stone beads and braided hemp. Warm and grounding.",
    style: "Boho", material: "Thread", colors: ["Sand", "Brown", "Gold"],
    rating: 4.5, reviewCount: 95, bestseller: false, newArrival: false,
    sizes: ["Adjustable"], careInfo: "Keep dry. Spot clean.", gradient: gradients[21],
    image: bohoSahara1,
  },
  {
    id: "22", name: "Peach Blossom Delicate Chain", price: 27, cogs: 9,
    description: "A fine chain bracelet with tiny peach enamel flower charms. Spring in jewelry form.",
    style: "Charm", material: "Wire", colors: ["Peach", "Gold"],
    rating: 4.6, reviewCount: 142, bestseller: false, newArrival: true,
    sizes: ["S/M", "M/L"], careInfo: "Avoid perfume contact.", gradient: gradients[22],
    image: charmPeach1,
  },
  {
    id: "23", name: "Moss Agate Earth Band", price: 41, cogs: 13,
    description: "Genuine moss agate stones threaded on elastic. Each stone has unique natural inclusions.",
    style: "Beaded", material: "Beads", colors: ["Green", "White"],
    rating: 4.7, reviewCount: 63, bestseller: false, newArrival: false,
    sizes: ["S/M", "M/L"], careInfo: "Avoid harsh chemicals.", gradient: gradients[23],
    image: beadedMossagate1,
  },
  {
    id: "24", name: "Candy Bead Kids Set", price: 12, cogs: 3,
    description: "Colorful acrylic bead bracelets perfect for kids. Set of 3 fun, stretchy bands.",
    style: "Friendship", material: "Beads", colors: ["Multi", "Pink", "Blue"],
    rating: 4.3, reviewCount: 287, bestseller: false, newArrival: false,
    sizes: ["Adjustable"], careInfo: "Stretch gently. Not for children under 3.", gradient: gradients[24],
    image: friendshipCandy1,
  },
  {
    id: "25", name: "Vintage Lace Cuff", price: 33, cogs: 10,
    description: "A romantic cuff bracelet combining vintage lace with delicate wire framing. Victorian charm meets modern craft.",
    style: "Boho", material: "Thread", colors: ["Cream", "White"],
    rating: 4.6, reviewCount: 78, bestseller: false, newArrival: false,
    sizes: ["S/M", "M/L"], careInfo: "Dry clean only. Handle delicately.", gradient: gradients[12],
    image: bohoVintageLace1,
  },
  {
    id: "26", name: "Onyx Power Stone Band", price: 38, cogs: 11,
    description: "Black onyx beads on a stretch cord. A bold, grounding piece for strength and focus.",
    style: "Beaded", material: "Beads", colors: ["Black"],
    rating: 4.8, reviewCount: 156, bestseller: false, newArrival: false,
    sizes: ["S/M", "M/L"], careInfo: "Wipe with soft cloth.", gradient: gradients[25],
    image: beadedOnyx1,
  },
  {
    id: "27", name: "Tropical Braided Anklet", price: 16, cogs: 4,
    description: "Bright, fun braided anklet with tiny shell accents. Made for sunny days and sandy toes.",
    style: "Friendship", material: "Thread", colors: ["Teal", "Coral", "Yellow"],
    rating: 4.4, reviewCount: 198, bestseller: false, newArrival: true,
    sizes: ["Adjustable"], careInfo: "Water-friendly. Air dry.", gradient: gradients[26],
    image: friendshipTropical1,
  },
  {
    id: "28", name: "Hammered Bronze Bangle", price: 65, cogs: 22,
    description: "A statement bangle hand-hammered from solid bronze. Each dent tells a story of artisan craftsmanship.",
    style: "Minimalist", material: "Wire", colors: ["Bronze"],
    rating: 4.9, reviewCount: 47, bestseller: false, newArrival: false,
    sizes: ["S/M", "M/L"], careInfo: "Will develop patina. Polish to restore shine.", gradient: gradients[27],
    image: minimalistBronze1,
  },
  {
    id: "29", name: "Cherry Blossom Silk Tie", price: 24, cogs: 7,
    description: "A silk-thread bracelet with hand-painted cherry blossom ceramic beads. Delicate and artistic.",
    style: "Charm", material: "Thread", colors: ["Pink", "White"],
    rating: 4.7, reviewCount: 109, bestseller: false, newArrival: false,
    sizes: ["Adjustable"], careInfo: "Avoid water. Store flat in pouch.", gradient: gradients[28],
    image: charmCherryblossom1,
  },
  {
    id: "30", name: "Custom Initial Leather Cuff", price: 49, cogs: 17,
    description: "A hand-stamped leather cuff with your initial. The perfect personalized gift or treat for yourself.",
    style: "Minimalist", material: "Leather", colors: ["Brown", "Black", "Tan"],
    rating: 4.9, reviewCount: 234, bestseller: true, newArrival: false,
    sizes: ["S/M", "M/L"], careInfo: "Condition with leather oil.", gradient: gradients[29],
    image: leatherInitial1,
  },
];

export const styles = ["Boho", "Minimalist", "Beaded", "Charm", "Friendship"];
export const materials = ["Thread", "Beads", "Wire", "Leather"];
export const allColors = ["Black", "Brown", "Gold", "Silver", "Pink", "Blue", "Green", "White", "Multi", "Red", "Purple", "Orange", "Natural", "Teal"];
